// src/components/Accordion/Accordion.jsx
import React, { useState } from "react";
import {
  FaSearch,
  FaLaptopCode,
  FaCheckCircle,
} from "react-icons/fa";
import "./Accordion.css";

const steps = [
  {
    title: "Recherche & Plannification",
    content:
      "Nous analysons vos besoins, le marché et vos objectifs afin de proposer une stratégie claire et efficace.",
    icon: <FaSearch className="accordion-step-icon" />,
  },
  {
    title: "Conception & Développement Web",
    content:
      "Nos designers et développeurs conçoivent des interfaces modernes et des applications performantes adaptées à vos attentes.",
    icon: <FaLaptopCode className="accordion-step-icon" />,
  },
  {
    title: "Test & Déploiement",
    content:
      "Chaque solution est testée et optimisée avant déploiement pour garantir fiabilité et performance.",
    icon: <FaCheckCircle className="accordion-step-icon" />,
  },
];

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="accordion-section">
      <h2 className="accordion-title">Pourquoi nous choisir ?</h2>
      <div className="accordion">
        {steps.map((step, index) => (
          <div key={index} className="accordion-item">
            <div
              className={`accordion-header ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggle(index)}
            >
              <div className="accordion-header-left">
                {step.icon}
                <h3>{step.title}</h3>
              </div>
              <span className="accordion-toggle">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            <div
              className={`accordion-content ${activeIndex === index ? "open" : ""}`}
            >
              <p>{step.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accordion;
